import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ClinicalServiceTypes } from "../../text/data";
import { Link } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { XMarkIcon } from "@heroicons/react/24/outline";
import InterventionCreate from "../service-steps/medication/interventionCreate";
import TreatmentModal from "./TreatmentModal";
import NewToolTip from "../../../common/New-ToolTip";

const SubNavigation = () => {
  const { clinicalServiceName } = useSelector((state) => state.clinicalService);
  const [showTreatmentAlgo, setShowTreatmentAlgo] = useState(false);
  const [showInterventionDialog, setShowInterventionDialog] = useState(false);

  return (
    <>
      <div className="flex">
        <div className="flex gap-10 font-medium text-teal-300 pr-2">
          <Link
            to="#"
            className="text-[16px] leading-[20px] pb-2 border-b-[3px] border-white hover:border-teal-300"
            data-tooltip-id="profileAnalysisTooltip"
            onClick={(e) => e.preventDefault()}
          >
            Profile Analysis
          </Link>
          <NewToolTip
            id="profileAnalysisTooltip"
            render={() => (
              <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2">
                Coming Soon
              </div>
            )}
          />
          {clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis && (
            <>
              <Link
                to="#"
                className="text-[16px] leading-[20px] pb-2 border-b-[3px] border-white hover:border-teal-300 "
                data-tooltip-id="minorAilmentSummaryTooltip"
                onClick={(e) => e.preventDefault()}
              >
                Minor Ailment Summary
              </Link>
              <NewToolTip
                id="minorAilmentSummaryTooltip"
                render={() => (
                  <div className="!bg-gray-20 max-w-[460px] text-teal-300 text-body-sm p-2">
                    Coming Soon
                  </div>
                )}
              />
              <Link
                to="#"
                className={`text-[16px] leading-[20px] pb-2 border-b-[3px] border-white hover:border-teal-300 `}
                onClick={(e) => {
                  e.preventDefault();
                  setShowTreatmentAlgo(true);
                }}
              >
                Treatment Algorithm
              </Link>
              
            </>
          )}
          <Link
            to="#"
            className={`text-[16px] leading-[20px] pb-2 border-b-[3px] hover:border-teal-300  ${
              showInterventionDialog ? "border-teal-300" : "border-white"
            }`}
            onClick={(e) => {
              e.preventDefault();
              setShowInterventionDialog(true);
            }}
          >
            Add Intervention
          </Link>
        </div>

        <InterventionCreate
          open={showInterventionDialog}
          onClose={(value) => setShowInterventionDialog(false)}
        />

        {showTreatmentAlgo && (
          <TreatmentModal
            open={showTreatmentAlgo}
            onCross={() => {
              setShowTreatmentAlgo(false);
            }}
          />
        )}
      </div>
    </>
  );
};

export default SubNavigation;
